import React, { Component } from "react";
import { Edit } from '@mui/icons-material'
import { IconButton } from "@mui/material";

interface BtnRenderProps {
    clicked: (id: string, rowData: any) => void;
    data: any;
}

class BtnCellRenderer extends Component<BtnRenderProps>{

    constructor(props: any) {
        super(props);
        this.btnClickedHandler = this.btnClickedHandler.bind(this);
    }

    btnClickedHandler() {
        this.props.clicked(this.props.data.id, this.props.data);
    }
    
    render() {
        return (
            <>
                <IconButton size='medium'onClick={this.btnClickedHandler}>
                    <Edit></Edit>
                </IconButton>
            </>
        )
    }
}
export default BtnCellRenderer;